import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

interface ChangeLogReasonProps {
  changeLogMessage: string;
  setChangeLogMessage: (message: string) => void;
  changeLogLength: number;
}

export default function ChangeLogReason({
  changeLogMessage,
  setChangeLogMessage,
  changeLogLength,
}: ChangeLogReasonProps) {
  const theme = useTheme();

  return (
    <Stack
      sx={{
        display: 'flex',
        padding: '20px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '12px',
        alignSelf: 'stretch',
        borderRadius: '4px',
        bgcolor:
          theme.palette.mode === 'dark'
            ? theme.palette.grey[800]
            : theme.palette.grey[50],
        border: '1px solid',
        borderColor: 'divider',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          color: 'text.primary',
          fontWeight: 600,
          ml: -1.5,
          mt: -1.5,
        }}
      >
        Change Log Reason
      </Typography>
      <TextField
        id="changeLog"
        helperText={`${changeLogMessage.length}/${changeLogLength}`}
        label="Reason for change"
        fullWidth
        autoComplete="off"
        multiline
        rows={2}
        value={changeLogMessage}
        onChange={(event) => {
          setChangeLogMessage(event.target.value);
        }}
        sx={
          theme.palette.mode === 'dark'
            ? { mb: -1.5 }
            : {
                mb: -1.5,
                '& .MuiInputBase-root': {
                  backgroundColor: '#fff',
                },
                '& textarea': {
                  backgroundColor: '#fff',
                  color: 'inherit',
                },
              }
        }
      />
    </Stack>
  );
}
